import * as React from 'react'
import { Box } from "@mui/material"
import {TooltipSeeker} from "@ui-seeker/core"
import {formatNumber, isEmpty} from "@ui-seeker/utils"

import { MARKETPLACES_ROUTES } from '@constants'
import { currentPeriod, encodeCommonFiltersShareValue, endDate, startDate } from '@signals'


export default function reaonsColumn(reasonsInfo) {
	return {
		name: 'reasonsPercentages', label: 'Reasons Share',
		options: {
			filter: false,
			customBodyRowRenderLite: (value, row) => <GraphBar dict={value} reasonsInfo={reasonsInfo} rowData={row}/>
			}
		}
	}

const GraphBar = ({dict, reasonsInfo, rowData}) => {
	if (isEmpty(dict)) return <></>

	const total = Object.values(dict).reduce((acc, value) => acc + value, 0)

    const generateRedirectUrl = (reasonID, rowData) => {
        const redirectFilters = {
            sku: [rowData.skuID],
            lostBuyBoxReason: [reasonID],
            retailer: [rowData.siteID],
            currentPeriod: currentPeriod.value,
            startDate: startDate.value,
            endDate: endDate.value
        }
        const url = `${MARKETPLACES_ROUTES.LBBDETAILS_PATH}?sp=${encodeCommonFiltersShareValue(redirectFilters)}`
        return window.open(url)
    }

	return <Box sx={{display: 'flex', height: '15px', width: '100%', borderRadius: '10px', overflow: 'hidden'}}>
		{Object.keys(dict).map((key) => {
			const percentage = (dict[key] / total) * 100

			return <TooltipSeeker key={key} title={`${key}: ${formatNumber(percentage, {decimals: 0})}%`}>
				<Box 
                    sx={{width: `${percentage}%`, backgroundColor: reasonsInfo[key].color, height: '100%'}} 
                    onClick={() => generateRedirectUrl(reasonsInfo[key].id, rowData)}
                />
			</TooltipSeeker>
		})}
	</Box>
}
